"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var axios_1 = __importDefault(require("axios"));
var ErrorPanel_1 = __importDefault(require("../../components/globals/ErrorPanel"));
var Loading_1 = __importDefault(require("../../components/globals/Loading"));
var CheckEmail = /** @class */ (function (_super) {
    __extends(CheckEmail, _super);
    function CheckEmail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultColXl = 9;
        _this.defaultColLd = 9;
        _this.defaultColMd = 9;
        _this.defaultColSm = 11;
        _this.defaultColXs = 11;
        _this.email = "";
        _this.hasError = false;
        _this.complete = false;
        _this.loading = false;
        return _this;
    }
    CheckEmail.prototype.refs = function () {
        return this.$refs;
    };
    CheckEmail.prototype.getMessage = function (errors) {
        if (errors.length) {
            return this.$t('view.contract_form.confirm_email.messages.error.email');
        }
        return "";
    };
    CheckEmail.prototype.mounted = function () {
        this.$emit('title-change', '');
    };
    CheckEmail.prototype.sendEmail = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var self_, _a, url_, params;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        event.preventDefault();
                        self_ = this;
                        self_.loading = true;
                        _a = self_;
                        return [4 /*yield*/, this.refs().inputObserver.validate()];
                    case 1:
                        _a.hasError = !(_b.sent());
                        if (self_.hasError) {
                            self_.loading = false;
                            return [2 /*return*/];
                        }
                        url_ = self_.$invokeUrlMaker.create('check_email');
                        params = JSON.stringify({
                            email: self_.email
                        });
                        axios_1.default.post(url_, params).then(function (res) {
                            self_.complete = true;
                            self_.loading = false;
                        }).catch(function (err) {
                            self_.loading = false;
                            console.log(err);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CheckEmail = __decorate([
        vue_property_decorator_1.Component({
            components: { Loading: Loading_1.default, ErrorPanel: ErrorPanel_1.default }
        })
    ], CheckEmail);
    return CheckEmail;
}(vue_property_decorator_1.Vue));
exports.default = CheckEmail;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/contract_form/CheckEmail.vue
// module id = fqbk
// module chunks = 1